import React, { useState } from 'react';
import { FilterMatchMode } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from 'primereact/multiselect';

import '../static/styles/Catalogue.css';


const MOBILE_FIELDS = ['title', 'stars', 'link'];

export default function Catalogue({ data, columns, filterFields, selectedFields }) {
    const resolveInitialColumns = () => {
        if (typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches) {
            return columns.filter((col) => MOBILE_FIELDS.includes(col.field));
        }

        return columns.filter((col) => selectedFields.includes(col.field));
    };

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [selectedColumns, setSelectedColumns] = useState(resolveInitialColumns);

    const onGlobalFilterChange = (e) => {
        setFilters({ global: { value: e.target.value, matchMode: FilterMatchMode.CONTAINS } });
        setGlobalFilterValue(e.target.value);
    };

    const renderHeader = () => (
        <div className="flex justify-content-between flex-column md:flex-row">
            <IconField className='w-full md:w-50' iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
            </IconField>
            <MultiSelect 
                value={selectedColumns} 
                options={columns} 
                optionLabel="header" 
                onChange={(e) => {
                    const uniqueColumns = columns.filter(col => e.value.some(selected => selected.field === col.field));
                    setSelectedColumns(uniqueColumns);
                }} 
                placeholder="Select columns" 
                display="chip" 
                className="w-full" 
            />
        </div>
    );

    const header = renderHeader();

    return (
        <DataTable value={Array.isArray(data) ? data : []} dataKey="id" removableSort stripedRows filters={filters} globalFilterFields={filterFields} header={header} emptyMessage="No records found!">
            {selectedColumns.map(col => (
                <Column key={col.field} field={col.field} header={col.header} body={col.bodyTemplate} sortable={col.sortable} style={col.style} />
            ))}
        </DataTable>
    );
}
